import {
  CONVERSATION_MEMBER_OVERRIDES,
  CONVERSATION_MEMBER_PERMISSIONS,
  CONVERSATION_MEMBER_ROLE,
  CONVERSATION_MEMBER_TRANSFER
} from '@/config/api/api-routes';
import { http } from '@/shared/api/http';
import type { ResultApi } from '@/shared/types/result-api';
import type {
  AssignRoleRequestDto,
  TransferOwnershipRequestDto,
  UpdatePermissionOverridesRequestDto,
  UserPermissionOverridesDto,
  UserPermissionsDto
} from '../models/permission';

export const getUserPermissions = async (conversationId: string): Promise<UserPermissionsDto> => {
  const url = CONVERSATION_MEMBER_PERMISSIONS.replace(':conversationId', conversationId);
  const response = await http.get<ResultApi<UserPermissionsDto>>(url);
  if (!response.data.data) throw new Error('Failed to get permissions');
  return response.data.data;
};

export const assignMemberRole = async (conversationId: string, request: AssignRoleRequestDto): Promise<void> => {
  const url = CONVERSATION_MEMBER_ROLE.replace(':conversationId', conversationId);
  await http.post(url, request);
};

export const transferOwnership = async (
  conversationId: string,
  request: TransferOwnershipRequestDto
): Promise<void> => {
  const url = CONVERSATION_MEMBER_TRANSFER.replace(':conversationId', conversationId);
  await http.post(url, request);
};

export const getMemberOverrides = async (
  conversationId: string,
  memberId: string
): Promise<UserPermissionOverridesDto> => {
  const url = CONVERSATION_MEMBER_OVERRIDES.replace(':conversationId', conversationId).replace(':memberId', memberId);
  const response = await http.get<ResultApi<UserPermissionOverridesDto>>(url);
  if (!response.data.data) throw new Error('Failed to get overrides');
  return response.data.data;
};

export const updateMemberOverrides = async (
  conversationId: string,
  memberId: string,
  request: UpdatePermissionOverridesRequestDto
): Promise<UserPermissionOverridesDto> => {
  const url = CONVERSATION_MEMBER_OVERRIDES.replace(':conversationId', conversationId).replace(':memberId', memberId);
  const response = await http.put<ResultApi<UserPermissionOverridesDto>>(url, request);
  if (!response.data.data) throw new Error('Failed to update overrides');
  return response.data.data;
};
